import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CallButton } from "../ui/ContactLinks";
import { trackLead } from "../lib/pixel";
import { SITE } from "../config/site";
import { useI18n } from "../i18n";
import Seo from "../seo/Seo";
import logo from "../assets/img/logo.svg";
import keysGif from "../assets/pixel/keys.gif";
import "../scss/simple-pages.scss";

export default function ThankYou() {
  const { t, lp } = useI18n();
  const { state } = useLocation();
  const tracked = useRef(false);

  // The Lead event fires only after a real form submission (not on page refresh).
  useEffect(() => {
    if (state?.lead && !tracked.current) {
      tracked.current = true;
      trackLead(state.source || "landing", state.interesovanje ? { interesovanje: state.interesovanje } : {});
      window.history.replaceState({}, "");
    }
  }, [state]);

  return (
    <main className="simple-page">
      <Seo title={t("seo.thanks.title")} description={t("seo.thanks.description")} noindex />
      <div className="simple-card">
        <Link to={lp("/")} className="simple-logo" aria-label={t("common.home")}>
          <img src={logo} alt="Tehnočin DOO Invest" width="130" height="85" />
        </Link>
        <img src={keysGif} alt="" className="pixel simple-art" width="48" height="48" />
        <h1>{t("thanks.title")}</h1>
        <p>{t("thanks.text")}</p>
        <div className="simple-actions">
          <CallButton className="btn btn--accent btn--lg btn--block" source="hvala">
            {t("common.call")} {SITE.phoneDisplay}
          </CallButton>
          <Link to={lp("/katalog")} className="btn btn--ghost btn--lg btn--block">
            {t("thanks.see")}
          </Link>
        </div>
        <Link to={lp("/")} className="simple-back">
          <ArrowLeft size={16} /> {t("common.backHome")}
        </Link>
      </div>
    </main>
  );
}
